import clsx from 'clsx'
import { CategoriaNotificacaoType } from '_metronic/helpers'
import { NotificacaoIcone } from './NotificacaoIcone'
import styles from './styles/NotificacaoToastContent.module.scss'

type Props = {
  titulo: string
  texto?: string
  categoria?: CategoriaNotificacaoType
  /** Texto do link no rodapé do toast. */
  acao?: string
}

/**
 * Conteúdo exibido dentro do Toast genérico (`app/components/Toast`) quando uma
 * notificação é recebida. A "moldura" do toast (fundo, borda, botão de fechar,
 * clique) é responsabilidade do componente genérico.
 */
export const NotificacaoToastContent = ({
  titulo,
  texto,
  categoria,
  acao = 'Ver notificação',
}: Props) => (
  <>
    <NotificacaoIcone categoria={categoria} />
    <div className={styles.body}>
      <div className='fs-7 fw-bold'>{titulo}</div>
      {texto && <div className={clsx('fs-8', styles.texto)}>{texto}</div>}
      <span className={clsx('fs-8', styles.link)}>{acao}</span>
    </div>
  </>
)
